import { ValidationErrors } from 'final-form';
import { EventFormData } from '~admin/view/components/details/event-form-data';
import { validate, validateArrayField } from '~common/validator';
import { after, before, futureDateValidation, required } from '~common/validator/validations';

/**
 * Returns all validators for event details page
 * @param values
 */
export const editEventDetailsValidators = (
  values: EventFormData,
): ValidationErrors | undefined => ({
  ...validateArrayField(values, 'eventName', [required()]),
  avatarMedia: validate(values.avatarMedia, [required()]),
  defaultMedia: validate(values.defaultMedia, [required()]),
  emailMedia: validate(values.emailMedia, [required()]),
  landscapeVideo: validate(values.landscapeVideo, [required()]),
  eventDateTimeStart: validate(values.eventDateTimeStart, [
    required(),
    after(values.eventDateTimeEnd),
  ]),
  eventDateTimeEnd: validate(values.eventDateTimeEnd, [
    required(),
    futureDateValidation(),
    before(values.eventDateTimeStart),
  ]),
  discoverDateStart: validate(values.discoverDateStart, [
    required(),
    after(values.discoverDateEnd),
  ]),
  discoverDateEnd: validate(values.discoverDateEnd, [
    required(),
    futureDateValidation(),
    before(values.discoverDateStart),
  ]),
  doorsOpenDate: validate(values.doorsOpenDate, [required(), futureDateValidation()]),
  ticketLimit: validate(values.ticketLimit, [required()]),
});



// WEBPACK FOOTER //
// ./view/components/edit-event/helper/edit-event-validators.helper.ts